// extracted by mini-css-extract-plugin
module.exports = {"DarkTheme__toggle___32LRg":"DarkTheme__toggle___32LRg","DarkTheme__switch___3dJxv":"DarkTheme__switch___3dJxv","DarkTheme__toggle-value___3WK4M":"DarkTheme__toggle-value___3WK4M"};